export const heroSlides = [
  {
    id: "hero-1",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20long%20dinner%20table%20at%20night%20surrounded%20by%20adults%20reuniting%20after%20many%20years%2C%20warm%20hanging%20lamps%20over%20the%20table%2C%20deep%20blue%20night%20tones%20with%20warm%20amber%20highlights%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1920&height=1080&seq=hero-reunion-dinner&orientation=landscape",
    kicker: "焦点剧集",
    title: "十年后，我们又坐在了同一张餐桌前",
    desc: "同学会开场的第一句寒暄，藏着每个人都想说却没说出口的十年前。",
  },
  {
    id: "hero-2",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20scattered%20old%20class%20photographs%20and%20a%20worn%20notebook%20on%20a%20wooden%20desk%20under%20a%20single%20desk%20lamp%2C%20deep%20blue%20shadows%20with%20warm%20amber%20light%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1920&height=1080&seq=hero-old-photos&orientation=landscape",
    kicker: "剧情看点",
    title: "被翻开的同学录，写满没人承认的旧账",
    desc: "一页合照背后，是三个人都记得却都不愿提起的那个夏天。",
  },
  {
    id: "hero-3",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20lonely%20figure%20standing%20under%20streetlights%20in%20the%20rain%20outside%20a%20lit%20apartment%20building%2C%20deep%20blue%20rainy%20atmosphere%20with%20warm%20amber%20window%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1920&height=1080&seq=hero-rainy-night&orientation=landscape",
    kicker: "最新更新",
    title: "雨夜的那通电话，让所有人都无法再假装",
    desc: "更新至第 16 集 —— 天台再会，真相只剩最后一层窗户纸。",
  },
];

export const episodeList = [
  {
    id: "ep-01",
    number: 1,
    title: "十年之约",
    airDate: "2025-08-12",
    duration: "45分钟",
    summary:
      "沈书言在群里发出同学会邀约，一场迟到十年的重逢就此定下，而所有人的生活也开始出现第一道裂纹。",
    synopsis: [
      "深夜的出租屋里，沈书言翻着手机里那个沉默了近两年的高中同学群，最终敲下一行字：“周末，老地方，聚一聚吧。”消息发出去不到十分钟，群里就炸开了锅，有人起哄，有人犹豫，也有人始终没有回应。",
      "同学会定在城东那家开了十几年的老菜馆。十年过去，当年穿校服的少年少女如今都换上了体面的外套，彼此寒暄着工作、家庭和孩子。沈书言的妻子苏雯替他整理衣领，笑着说要替他撑场面，却没注意到丈夫那一瞬间的失神。",
      "饭局过半，老班长陆明远举起酒杯，提议每人说一件“十年里最后悔的事”。话音落下，包间里安静了几秒。就在这个时候，风尘仆仆的顾南川推门而入，手里拎着一个旧牛皮纸袋，所有人的笑容都僵在了脸上。",
    ],
    tags: ["同学会", "重逢", "主线开启"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20private%20dining%20room%20with%20a%20long%20table%20and%20a%20man%20raising%20a%20toast%2C%20warm%20lantern%20light%20mixed%20with%20deep%20blue%20evening%20shadows%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-01-cover&orientation=landscape",
    castIds: ["chen-rui", "lin-wan", "zhou-yu", "xu-cheng"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-02",
    number: 2,
    title: "那本同学录",
    airDate: "2025-08-13",
    duration: "44分钟",
    summary:
      "方晴翻出一本旧同学录，留言页里夹着的字句让在座的人脸色各异，有人试图把话题岔开。",
    synopsis: [
      "顾南川把牛皮纸袋放在桌上，里面是一本被翻得起毛边的同学录。他说这是十年前毕业那天，有人塞进他书包里的，却一直没有署名。",
      "方晴抢过同学录，一页页念着上面的留言。大多数都是嬉笑打闹的祝福，可翻到中间那几页时，她的声音明显顿了一下——那段字迹苍劲的留言，与在场某个人的笔迹几乎一模一样。",
      "陆明远适时地端起酒杯大笑，说这本破本子有什么好念的，硬是把话题带到了生意和房价上。但苏雯注意到，从同学录被翻开的那一刻起，丈夫的手就一直没有离开过桌下的膝盖。",
    ],
    tags: ["同学录", "笔迹", "旧账"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20worn%20class%20autograph%20notebook%20being%20flipped%20open%20by%20a%20woman%20under%20warm%20table%20light%2C%20deep%20blue%20ambient%20shadow%20in%20the%20background%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-02-cover&orientation=landscape",
    castIds: ["he-jia-nan", "chen-rui", "zhou-yu", "lin-wan"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-03",
    number: 3,
    title: "迟到的座位",
    airDate: "2025-08-19",
    duration: "45分钟",
    summary:
      "一张本该空着的椅子被人拉开，唐心怡的到来让这场同学会彻底变了味道。",
    synopsis: [
      "同学会第二天，众人约在一家清吧续摊。沈书言到的比谁都早，他习惯性地在长桌尽头留了一个空位，这个动作被苏雯默默记在了心里。",
      "唐心怡踩着高跟鞋出现时，整个清吧都安静了半拍。她是当年班里的风云人物，毕业后嫁给了一位企业家，朋友圈里永远是精致的旅行和下午茶。可今晚的她，妆化得比平时更浓，笑得也比照片里更用力。",
      "她径直走向沈书言为他留的那个空位坐下，笑着说“我记得你一直坐我旁边”。苏雯端着酒杯的手停在半空，陆明远适时地递上果盘，试图让气氛重新热闹起来，却谁都没有接话。",
    ],
    tags: ["唐心怡登场", "旧位置", "暗流"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20quiet%20cocktail%20bar%20with%20a%20woman%20in%20a%20dress%20sitting%20down%20at%20the%20end%20of%20a%20long%20counter%2C%20deep%20blue%20interior%20tones%20with%20warm%20bottle%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-03-cover&orientation=landscape",
    castIds: ["qi-yan", "chen-rui", "lin-wan", "zhou-yu"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-04",
    number: 4,
    title: "旧照片里的第三个人",
    airDate: "2025-08-20",
    duration: "43分钟",
    summary:
      "一张毕业合影被放大后，背景里多出的第三个人影，牵出了所有人都想回避的那件事。",
    synopsis: [
      "方晴把毕业那天的合影投到客厅的电视上，说是要给聚会做一支纪念短片。放大的照片一张张划过，众人笑着指认谁当年最调皮、谁偷偷换了发型。",
      "直到那张天台合影出现，方晴突然按下了暂停键。照片的角落里，站在人群背后、几乎被裁掉的位置上，站着一个模糊的身影。可那天，本该只有照片里的这些人。",
      "江雪凑近看了许久，轻声说了一句“那不是我们班的”。这句话像一根针，把包间里好不容易积攒起来的暖意，一下子扎破了。",
    ],
    tags: ["合影", "多出的人", "悬念"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20group%20graduation%20photo%20projected%20on%20a%20living%20room%20wall%20with%20a%20blurred%20extra%20figure%20in%20the%20corner%2C%20deep%20blue%20room%20tone%20with%20warm%20projector%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-04-cover&orientation=landscape",
    castIds: ["he-jia-nan", "luo-xi", "chen-rui", "xu-cheng"],
    director: "顾承安",
    screenwriter: "裴之远",
  },
  {
    id: "ep-05",
    number: 5,
    title: "未发出的语音",
    airDate: "2025-08-26",
    duration: "45分钟",
    summary:
      "沈书言的手机里躺着一段始终没有发出去的语音，收件人却已经不在通讯录里。",
    synopsis: [
      "加班回家的路上，沈书言在车里翻找一份文件，无意中点开了草稿箱。那里躺着一封十年前的语音，时间戳是毕业典礼的第二天凌晨，收件人一栏却是空的。",
      "他没有点开那段语音，只是把手机锁屏，靠在椅背上很久。回到家时，苏雯还在等他，桌上温着一碗汤。两人谁都没有提起同学会上的事，却在同一个眼神里读出了对方的欲言又止。",
      "同一时间，顾南川在酒店房间里拆开了那个牛皮纸袋，里面除了同学录，还有一张被折了很多次的纸条。他盯着纸条上的字迹，缓缓拨通了一个十年没打过的号码。",
    ],
    tags: ["语音", "草稿箱", "婚姻"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20man%20sitting%20alone%20in%20a%20parked%20car%20at%20night%20holding%20his%20phone%2C%20deep%20blue%20night%20interior%20with%20warm%20dashboard%20light%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-05-cover&orientation=landscape",
    castIds: ["chen-rui", "lin-wan", "xu-cheng"],
    director: "顾承安",
    screenwriter: "裴之远",
  },
  {
    id: "ep-06",
    number: 6,
    title: "雨夜的代驾",
    airDate: "2025-08-27",
    duration: "44分钟",
    summary:
      "一场暴雨里，一个代驾司机把两个人送回了同一栋楼，也让一个秘密再也藏不住。",
    synopsis: [
      "同学会散场后遇上暴雨，众人叫不到车。沈书言和唐心怡恰好被安排上同一辆代驾的车，司机说顺路，先送谁由他们决定。",
      "车里很安静，只有雨刷来回摆动的声音。唐心怡忽然开口，说她这些年过得并不像朋友圈里那么好看。沈书言没有接话，只是看着窗外被雨水打湿的城市灯火。",
      "车最终停在了同一栋公寓楼下——那是唐心怡说过的“投资用的小房子”。第二天，一张模糊的雨中照片出现在了同学群里，没有人配文字，所有人都看到了。",
    ],
    tags: ["雨夜", "代驾", "照片"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20rain%20streaming%20down%20a%20dark%20car%20window%20at%20night%20with%20blurred%20warm%20city%20lights%20beyond%2C%20deep%20blue%20rainy%20tone%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-06-cover&orientation=landscape",
    castIds: ["chen-rui", "qi-yan", "zhou-yu"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-07",
    number: 7,
    title: "账单上的名字",
    airDate: "2025-09-02",
    duration: "45分钟",
    summary:
      "苏雯在整理发票时，发现一张不该出现的餐厅账单，落款日期正是同学会那天。",
    synopsis: [
      "苏雯帮沈书言整理公文包里的票据，准备报销。一张明显不属于商务往来的餐厅账单混在里面，金额不大，日期却清清楚楚地写在同学会那晚。",
      "她没有当场质问，只是把账单拍照存进自己的相册，然后若无其事地问他晚上想吃什么。饭桌前的两个人像往常一样聊着琐碎的家常，可空气里第一次有了试探的味道。",
      "另一边，陆明远的公司因为一笔资金链问题陷入麻烦。他约沈书言吃饭，希望对方能帮忙周转，并意味深长地说：“有些事，翻出来对谁都没好处。”",
    ],
    tags: ["账单", "试探", "资金链"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20woman%20holding%20a%20restaurant%20receipt%20at%20a%20kitchen%20table%20lit%20by%20a%20single%20lamp%2C%20deep%20blue%20evening%20shadow%20with%20warm%20domestic%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-07-cover&orientation=landscape",
    castIds: ["lin-wan", "chen-rui", "zhou-yu"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-08",
    number: 8,
    title: "同学会第二夜",
    airDate: "2025-09-03",
    duration: "45分钟",
    summary:
      "为了给陆明远接风，众人再次聚齐，可这一夜，有人带来了录音笔，有人带来了律师函。",
    synopsis: [
      "陆明远的资金问题没能解决，他索性做东，把所有人又叫到了一起。这一次的包间比上次更大，菜色更贵，气氛却更冷。",
      "方晴察觉到了什么，悄悄打开了手机录音。江雪则罕见地带来了一个文件袋，说里面是十年前那件事的相关材料——如果有必要，她希望有人能说清楚。",
      "酒过三巡，陆明远终于提到了那笔“谁都以为已经过去”的钱。饭桌上再没有人举杯，只有筷子落在瓷盘上的轻响。",
    ],
    tags: ["第二夜", "录音笔", "律师函"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20tense%20banquet%20table%20at%20night%20with%20stiff%20faces%20and%20untouched%20dishes%2C%20deep%20blue%20room%20tones%20with%20warm%20overhead%20light%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-08-cover&orientation=landscape",
    castIds: ["zhou-yu", "he-jia-nan", "luo-xi", "chen-rui"],
    director: "顾承安",
    screenwriter: "裴之远",
  },
  {
    id: "ep-09",
    number: 9,
    title: "被删掉的一条朋友圈",
    airDate: "2025-09-09",
    duration: "43分钟",
    summary:
      "唐心怡半夜发出一条动态又秒删，截图却早已在同学之间传开。",
    synopsis: [
      "凌晨两点，唐心怡发了一条只有一张照片、没有文字的朋友圈，配图是窗台上的一杯水和一只药盒。不到一分钟，动态被删除了。",
      "可截图还是被眼疾手快的人保存了下来。第二天，这件事成了同学群里绕不开的话题。有人担心她的状态，有人却开始揣测这条动态是不是冲着某个人来的。",
      "苏雯把截图看了很久，最终没有转发。她给唐心怡发了一条私信，只写了六个字：“你还好吗，心怡。”这条消息，成了两个女人之间第一次、也是唯一一次坦诚的对话。",
    ],
    tags: ["朋友圈", "秒删", "女性视角"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20dim%20bedroom%20window%20sill%20with%20a%20glass%20of%20water%20and%20a%20small%20medicine%20box%20at%20night%2C%20deep%20blue%20lonely%20tone%20with%20warm%20lamp%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-09-cover&orientation=landscape",
    castIds: ["qi-yan", "lin-wan", "he-jia-nan"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-10",
    number: 10,
    title: "那年夏天的天台",
    airDate: "2025-09-10",
    duration: "45分钟",
    summary:
      "回忆正式拉开，十年前那个夏天的天台，藏着这场同学会真正的起点。",
    synopsis: [
      "顾南川终于把那张折了很多次的纸条摊开——上面只有一行字，约他三天后在教学楼天台见面，落款是十年前的那个夏天。",
      "剧情回到十年前：毕业前最后一个学期，天台上发生过一场无人知晓的争吵。沈书言、陆明远与那个如今已经不在班里的名字，曾经站在一起，也因为一件事彻底分道扬镳。",
      "回到现在，顾南川把纸条重新折好，放回牛皮纸袋。他说他不是来算账的，他只是想知道，当年那个答应会来天台的人，为什么最后没有出现。",
    ],
    tags: ["回忆线", "天台", "关键往事"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20school%20rooftop%20at%20dusk%20with%20three%20young%20silhouettes%20and%20a%20faded%20handwritten%20note%2C%20deep%20blue%20twilight%20tone%20with%20warm%20sunset%20edge%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-10-cover&orientation=landscape",
    castIds: ["xu-cheng", "chen-rui", "zhou-yu"],
    director: "顾承安",
    screenwriter: "裴之远",
  },
  {
    id: "ep-11",
    number: 11,
    title: "一封没有寄出的信",
    airDate: "2025-09-16",
    duration: "44分钟",
    summary:
      "沈父在老家阁楼里找到一封没有寄出的信，收信人正是当年那个被抹去的名字。",
    synopsis: [
      "沈书言回老家接父亲体检，父亲让他去阁楼搬一个旧箱子。箱子最底下，压着一封盖了邮戳却又被退回的信，收件人一栏，写着一个多年没人提起的名字。",
      "父亲沉默了许久，最终承认，那封信是他年轻时候写的，寄出去又被人退了回来。他说有些话，当时不说，后来就再也说不出口了。",
      "沈书言握着那封信，忽然明白了自己草稿箱里那段没有发出的语音，究竟是从哪里学来的习惯。有些沉默，是一代一代传下来的。",
    ],
    tags: ["信件", "父辈线", "沉默"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20an%20elderly%20man%20handing%20an%20old%20returned%20letter%20to%20his%20son%20in%20a%20dusty%20attic%2C%20deep%20blue%20shadow%20with%20warm%20window%20light%20beam%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-11-cover&orientation=landscape",
    castIds: ["yan-song", "chen-rui"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-12",
    number: 12,
    title: "谁在说谎",
    airDate: "2025-09-17",
    duration: "45分钟",
    summary:
      "三方各执一词，餐厅监控、录音笔与聊天记录被同时摆上桌面，谎言开始互相拆台。",
    synopsis: [
      "方晴终于把那段录音放了出来。录音里，有人承认那天晚上去过一个本不该出现的地方，语气里满是慌乱。录音一旦开始播放，包间里的每个人都坐不住了。",
      "江雪紧接着拿出了餐厅的消费记录，与某人的说法完全对不上。陆明远试图用“记错了”搪塞过去，却被方晴一句话顶了回去：“你可以记错一次，但不可能每一次都记错。”",
      "所有人的目光最后集中到了沈书言身上。他端起酒杯一饮而尽，说了一句让所有人意外的话：“这件事，从头到尾都不是你们想的那样。”",
    ],
    tags: ["对峙", "录音", "反转前夜"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20several%20harshly%20lit%20faces%20around%20a%20table%20confronting%20each%20other%20with%20documents%20on%20the%20surface%2C%20deep%20blue%20tension%20tone%20with%20warm%20harsh%20light%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-12-cover&orientation=landscape",
    castIds: ["he-jia-nan", "luo-xi", "zhou-yu", "chen-rui"],
    director: "顾承安",
    screenwriter: "裴之远",
  },
  {
    id: "ep-13",
    number: 13,
    title: "明远的账本",
    airDate: "2025-09-23",
    duration: "45分钟",
    summary:
      "陆明远资金链断裂的真相曝光，他苦撑多年的体面，在一个账本面前彻底崩塌。",
    synopsis: [
      "陆明远的公司正式进入清算程序。清算清单里，一笔十年前转出的款项再次出现，收款账户的名字，让所有人都愣住了。",
      "原来十年前那个夏天，陆明远为了替同学还一笔欠款，擅自挪用了本属于班费的钱。那笔钱至今没有还清，而这十年里，他一直用各种各样的方式在为自己找补。",
      "方晴气得发抖，说要报警。陆明远没有反驳，只是把账本推到桌子中间。他说他早就撑不住了，只是一直不敢面对那个被他弄丢的自己。",
    ],
    tags: ["账本", "体面崩塌", "十年前的钱"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20an%20open%20ledger%20of%20accounts%20on%20a%20desk%20with%20a%20tired%20man%20sitting%20behind%20it%2C%20deep%20blue%20cold%20tone%20with%20warm%20desk%20lamp%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-13-cover&orientation=landscape",
    castIds: ["zhou-yu", "he-jia-nan", "luo-xi"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-14",
    number: 14,
    title: "方晴的录音笔",
    airDate: "2025-09-24",
    duration: "43分钟",
    summary:
      "方晴把散落的录音整理完整，一段被剪掉的开头，让所有人的判断彻底翻转。",
    synopsis: [
      "方晴回家后把录音从头到尾听了一遍，才发现自己在聚会上播放时，因为太生气，跳过了开头的那几句话。",
      "而那几句被跳过的话，恰恰证明了沈书言当晚的确去过那个地方，去的原因也和所有人猜测的完全不同。他不是去赴约，而是去把一个人从悬崖边拉了回来。",
      "方晴捧着录音笔在沙发上坐到天亮，她第一次意识到，比起谎言，急着下结论的自己和所有人，也许才是更伤人的那一个。",
    ],
    tags: ["完整录音", "翻转", "误判"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20woman%20sitting%20on%20a%20sofa%20at%20dawn%20holding%20a%20small%20voice%20recorder%2C%20deep%20blue%20early%20morning%20tone%20with%20warm%20lamp%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-14-cover&orientation=landscape",
    castIds: ["he-jia-nan", "chen-rui", "qi-yan"],
    director: "顾承安",
    screenwriter: "裴之远",
  },
  {
    id: "ep-15",
    number: 15,
    title: "江雪的证词",
    airDate: "2025-09-30",
    duration: "45分钟",
    summary:
      "江雪以律师的身份，第一次把十年前的往事完整说出口，也第一次承认自己当年的沉默。",
    synopsis: [
      "作为当年唯一知情的旁观者，江雪终于决定把一切说清楚。她带来的是当年那份被压下来的记录，以及她亲手写下的证词。",
      "原来那个被抹去的名字，曾在毕业前托付给她一件事——替他保守一个秘密。江雪答应了，也因此沉默了整整十年。她说她不是不后悔，只是当时太年轻，以为沉默是一种善良。",
      "众人这才明白，这场同学会并不是谁在算账，而是所有人都在替十年前的自己，迟到了一个回答。",
    ],
    tags: ["证词", "旁观者", "真相揭晓"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20composed%20woman%20reading%20a%20written%20statement%20aloud%20in%20a%20quiet%20room%2C%20deep%20blue%20calm%20tone%20with%20warm%20window%20light%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-15-cover&orientation=landscape",
    castIds: ["luo-xi", "chen-rui", "xu-cheng"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
  {
    id: "ep-16",
    number: 16,
    title: "天台再会",
    airDate: "2025-10-01",
    duration: "46分钟",
    summary:
      "众人重回教学楼天台，这一次，没有人再选择沉默，而沈书言也终于按下了那条语音的播放键。",
    synopsis: [
      "同学会最后一夜，顾南川提议回到学校。老教学楼已经翻新，只有天台还保持着十年前的模样。夜色里，城市的灯火铺开在脚下，和十年前的夏天一模一样。",
      "沈书言终于当着所有人的面，点开了草稿箱里那段没有发出的语音。语音里，年轻的他声音发颤，说出了当年没有勇气说出口的那句话。听完整段语音，苏雯第一次走上前，握住了他的手。",
      "顾南川把牛皮纸袋留在了天台，里面那本同学录的最后一页，被写上了一行新的字。这一次，所有人都看清楚了落款——那是属于他们自己的名字。本集为已更新最后一集，后续剧集敬请期待。",
    ],
    tags: ["天台", "语音播放", "本季终"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20drama%20still%20of%20a%20group%20of%20adults%20standing%20together%20on%20a%20rooftop%20at%20night%20looking%20over%20city%20lights%2C%20deep%20blue%20night%20tone%20with%20warm%20distant%20glow%2C%20soft%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20moody%20dramatic%20tone%2C%20high%20detail&width=1200&height=675&seq=ep-16-cover&orientation=landscape",
    castIds: ["chen-rui", "lin-wan", "xu-cheng", "luo-xi"],
    director: "顾承安",
    screenwriter: "苏晚宁",
  },
];